module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-detail-header"
  }, [_c('div', {
    staticClass: "pull-left page-detail-title"
  }, [_c('span', {
    staticClass: "page-detail-span"
  }, [_c('i', {
    staticClass: "fa fa-sitemap"
  }), _vm._v("\n              当前ZK集群 : " + _vm._s(_vm.zkCluster || '全部ZK集群') + "\n          ")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.init
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "page-content",
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24,
      "xl": 12
    }
  }, [_c('Chart-container', {
    attrs: {
      "title": "失败率最高的Top10作业",
      "type": "bar"
    }
  }, [_c('div', {
    attrs: {
      "slot": "chart"
    },
    slot: "chart"
  }, [_c('Column', {
    attrs: {
      "id": "top10FailJob",
      "option-info": _vm.top10FailJobOptionInfo
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24,
      "xl": 12
    }
  }, [_c('Chart-container', {
    attrs: {
      "title": "最活跃的Top10作业(当天执行次数最多的作业)",
      "type": "bar"
    }
  }, [_c('div', {
    attrs: {
      "slot": "chart"
    },
    slot: "chart"
  }, [_c('Column', {
    attrs: {
      "id": "top10ActiveJob",
      "option-info": _vm.top10ActiveJobOptionInfo
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24,
      "xl": 12
    }
  }, [_c('Chart-container', {
    attrs: {
      "title": "负荷最重的Top10作业",
      "type": "bar"
    }
  }, [_c('div', {
    attrs: {
      "slot": "chart"
    },
    slot: "chart"
  }, [_c('Column', {
    attrs: {
      "id": "top10LoadJob",
      "option-info": _vm.top10LoadJobOptionInfo
    }
  })], 1)])], 1)], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-508e0dd3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dashboard_manage/job_statistic.vue
// module id = 1407
// module chunks = 1